import styled from 'styled-components'

export const RegisterContainer = styled.div`

`

export const Header = styled.header`

`